import { useEffect } from "react";

const BASE_TITLE = "Stardeck CMS";

/**
 * Hook to set the document title with consistent branding
 * @param title - The page-specific title (will be appended with " | Stardeck CMS")
 */
export function usePageTitle(title?: string) {
  useEffect(() => {
    document.title = title ? `${title} | ${BASE_TITLE}` : BASE_TITLE;

    return () => {
      document.title = BASE_TITLE;
    };
  }, [title]);
}
